
import React from 'react';
import {DashboardTable} from "../dashboard-table";
import {dump_timestamp, PAYMENTS_STYLE_LUT} from "./common";
import {centsToString} from "../../../lib/currency-utils";

const COLUMN_HEADERS = [
  "State", "Timestamp", "Name", "Account", "Amt",
];

const state_label = state => {
  if (state === "pending") {
    return "ACH Initiated by client";
  }
  if (state === "segregated-leg-paused") {
    return "Settled To Segregated Account";
  }
  return "UNKNOWN";
}

const generate_table_data = (items) => {
  const result = [ COLUMN_HEADERS ];

  for(let i=0; i < items.length; i++) {
    const item = items[i];
    if (!item.metadata.is_segregated_payment) {
      continue;
    }
    const line = [];
    line.push(state_label(item.metadata.transfer_state));
    line.push(dump_timestamp(item.timestamp_sec));
    line.push(item.metadata.to.name);
    line.push(item.metadata.to.account_number);
    line.push(centsToString(item.metadata.amt_cents));

    result.push(line);
  }
  return result;
}

const SegregatedPaymentsTable = props => {

  const selected_row = props.selected_row;

  if (props.items.length === 0) {
    return null;
  }

  const data = generate_table_data(props.items);

  const table_style = {
    width: "100%",
  }
  return (
    <div>
      <DashboardTable
        tableStyle={table_style}
        tdStyleLut={PAYMENTS_STYLE_LUT(selected_row)}
        data={data}
      />
    </div>
  )
}

export { SegregatedPaymentsTable };
